export default __webpack_public_path__ + "static/opdemo2-truaccent-b41373026fb3efabe8b0cff9e5c714c5.png";